// Tiny API helper
const RAW = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = RAW.replace(/\/+$/, "");
export const API = `${API_BASE}/api`;

export async function submitLead(payload) {
    const res = await fetch(`${API}/leads`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    if (!res.ok) {
        let detail = `Request failed (${res.status})`;
        try {
            const j = await res.json();
            detail = j.detail || detail;
        } catch (_) {}
        throw new Error(detail);
    }
    return res.json();
}
